module.exports = __webpack_public_path__ + "media/images/donation/logo-mitsui-3417088ee9a0ebe42c5f7e67eee63f21.jpg";